import type {SubscriptionTier} from '../SubscriptionTier.js'
import type {Project} from '../../projects/index.js'

export const validAmountOfProjectsForTier = (tier: SubscriptionTier, activeProjects: number | Project[]) => {
  const activeCount =
    typeof activeProjects === 'number'
      ? activeProjects
      : activeProjects.filter((project) => !project.archivedTime).length

  return activeCount <= tier.features.maxActiveProjects
}
